import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { values, pick } from 'lodash';
import { bindActionCreators } from 'redux';
import {
  HelpBlock, ControlLabel, FormControl,
  FormGroup, Button,
} from 'react-bootstrap';
import s from '../../../redux/selectors';
import a from '../../../redux/actions';
import types from '../../../types';
import { wrap, withT } from '../../../lib/wrappers';

const LoginForm = ({
  t, user, login, patch,
  password, loginFormValidations, loginFormErrors,
}) => (
  <div
    id="login_form"
  >
    <FormGroup
      validationState={loginFormErrors.errEmailNotFound ? 'error' : (loginFormValidations.email ? 'success' : null)}
    >
      <ControlLabel>{t('Email')}*</ControlLabel>
      <FormControl
        id="login_form__email"
        componentClass="input"
        type="text"
        value={user.email}
        onChange={e => patch({ user: { email: e.target.value } })}
      />
      {loginFormErrors.errEmailNotFound && <HelpBlock>{t('No user with provided email found.')}</HelpBlock>}
    </FormGroup>
    <FormGroup
      validationState={loginFormErrors.errPasswordIncorrect ? 'error' : null}
    >
      <ControlLabel>{t('Password')}*</ControlLabel>
      <FormControl
        id="login_form__password"
        componentClass="input"
        type="password"
        value={password}
        onChange={e => patch({ auth: { password: e.target.value } })}
      />
      {loginFormErrors.errPasswordIncorrect && <HelpBlock>{t('Password is incorrect.')}</HelpBlock>}
    </FormGroup>
    <Button
      id="login_form__submit"
      disabled={values(loginFormValidations).some(v => !v)}
      onClick={() => login(t)}
    >{t('Submit')}</Button>
  </div>

);

LoginForm.propTypes = {
  t: PropTypes.func.isRequired,
  login: PropTypes.func.isRequired,
  patch: PropTypes.func.isRequired,
  user: types.User.isRequired,
  password: PropTypes.string.isRequired,
  loginFormValidations: types.LoginFormValidations.isRequired,
  loginFormErrors: types.LoginFormErrors.isRequired,
};

const mapStateToProps = (state, ownProps) => [
  'user',
  'password',
  'loginFormErrors',
  'loginFormValidations',
].reduce((props, selector) => ({
  ...props,
  [selector]: s[selector](state, ownProps),
}), {});

const mapDispatchToProps = dispatch => bindActionCreators(
  pick(a, [
    'login',
    'patch',
  ]),
  dispatch,
);

export default wrap(
  withT('auth'),
  connect(mapStateToProps, mapDispatchToProps)(LoginForm),
);

